import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=8a1a740c&"
import script from "./InfoDetails.vue?vue&type=script&lang=js&"
export * from "./InfoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports